import router from "@/router";
import {Coupon} from "@/data/classes/coupon";
let coupon = new Coupon();

export const tabs : any[] = [
    {
        key: "general",
        label: "coupon-form.tabs.general",
        type: "single",
        sections: [
            {
                title: 'coupon-form.sections.main',
                inputs: [
                    {
                        label: 'coupon-form.description',
                        name: 'input_coupon_title',
                        type: 'text',
                        required: true,
                        path: "Description",
                        size: 50
                    },
                    {
                        label: 'coupon-form.type',
                        name: 'input_coupon_type',
                        type: 'select',
                        options: [{
                            key: "percentage",
                            label: "coupon-form.percentage",
                            value: "percentage"
                        },{
                            key: "amount",
                            label: "coupon-form.amount",
                            value: "amount"
                        }],
                        required: true,
                        path: "Type",
                        size: 50,
                    },
                ]
            },
            {
                title: 'coupon-form.sections.discount',
                inputs: [
                    {
                        label: 'coupon-form.percentage',
                        name: 'input_coupon_percentage',
                        type: 'number',
                        required: true,
                        path: "Percentage",
                        size: 100,
                        condition: (item: Coupon) : boolean => {
                            return item.Type === "percentage";
                        }
                    },
                    {
                        label: 'coupon-form.amount',
                        name: 'input_coupon_amount',
                        type: 'number',
                        required: true,
                        path: "Amount",
                        size: 100,
                        condition: (item: Coupon) : boolean => {
                            return item.Type !== "percentage";
                        }
                    },
                ]
            },
            {
                title: 'coupon-form.sections.expiration',
                inputs: [
                    {
                        label: 'coupon-form.expires-in-label',
                        name: 'input_coupon_expires_in',
                        type: 'select',
                        options: [{
                            key: "never",
                            label: "coupon-form.expires-in.never",
                            value: 0
                        },{
                            key: "once",
                            label: "coupon-form.expires-in.one-use",
                            value: 1
                        },{
                            key: "3-months",
                            label: "coupon-form.expires-in.3-months",
                            value: 3
                        },{
                            key: "6-months",
                            label: "coupon-form.expires-in.6-months",
                            value: 6
                        },{
                            key: "12-months",
                            label: "coupon-form.expires-in.12-months",
                            value: 12
                        }],
                        required: true,
                        path: "ExpiresIn",
                        size: 100
                    },
                ]
            },
            {
                title: "coupon-form.sections.action-codes",
                inputs: [
                    {
                        label: 'coupon-form.action-codes',
                        name: 'input_coupon_action_codes',
                        type: 'list',
                        required: false,
                        path: "ActionCodes",
                        size: 100,
                    },
                ]
            }
        ]
    },
]


export const getData = async () => {
    if (router.currentRoute.params.couponId !== "new"){
        await coupon.get(router.currentRoute.params.couponId);
    } else {
        coupon = new Coupon();
    }

    return coupon.toJSON();
}


export const onSubmit = async (formValues: any) => {
    // Set values
    coupon.set(formValues);

    // Update coupon
    return coupon.update();
}
